import { socketClosedListeners } from './socketClosedListeners'

/**
 * Registers a listener for the app's GraphQL WebSocket closing. Returns the function that removes it.
 *
 * graphql-ws retries a dropped socket and re-sends every subscription on its own, so a subscriber's own error and
 * complete callbacks never fire for a plain drop. The client's `closed` event is the only signal, and the library
 * documents `createClient({ on: { closed } })` as the place to register it (`ClientOptions.on`), so the client's
 * creator calls `notifySocketClosed` there and a subscriber that must stop on a drop calls this.
 */
export const onSocketClosed = (listener: () => void): (() => void) => {
  socketClosedListeners.add(listener)
  return () => {
    socketClosedListeners.delete(listener)
  }
}
